import { PauseOverlayInterface } from './Interface';
import type { PauseOverlayProps } from './types';

/** Thin container — pause logic stays in the app shell for now. */
export default function PauseOverlayContainer(props: PauseOverlayProps) {
  return <PauseOverlayInterface {...props} />;
}
